<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite">新增</el-button>
        <el-dropdown style="margin-left: 4px">
          <el-button type="primary" :disabled="Status === 2 || !canWrite"> 单据选择<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
          <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
            <el-dropdown-item class="dropdown-item" @click.native="openDialog('销售订单')"> 销售订单 </el-dropdown-item>
            <el-dropdown-item class="dropdown-item" @click.native="openDialog('发货通知单')"> 发货通知单 </el-dropdown-item>
            <el-dropdown-item class="dropdown-item" @click.native="openDialog('销货单')"> 销货单 </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="Status === 2 || !canWrite">保存</el-button>
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave || Status === 2 || !canWrite" @click="handleDelete">删除</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="reView" v-if="Status !== 2 || !canReview" :disabled="!isSave">审核</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="cancelReView" v-if="Status === 2 || !canReview" :disabled="!isSave">弃审</el-button>
        <el-dropdown style="margin-left: 4px">
          <el-button type="primary" :disabled="!isSave"> 联查<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
          <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
            <el-dropdown-item class="dropdown-item" @click.native="goJump(1)">销售订单情况</el-dropdown-item>
            <el-dropdown-item class="dropdown-item" @click.native="goJump(2)">销货单情况</el-dropdown-item>
            <!-- <el-dropdown-item class="dropdown-item">凭证情况</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave" @click="onPrint(data)">打印</el-button>
        <el-button type="primary" @click="openSetField">明细字段</el-button>
      </div>

      <el-form :model="data" ref="ruleForm" :inline="true" :line-form="true" :rules="rules" label-width="100px" status-icon>
        <el-row style="margin-top: 18px">
          <el-form-item label="单据日期:" label-width="100px" prop="DocDate">
            <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span>
            <el-date-picker v-else v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px" @change="val => getPreviewNo(val)">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码:" label-width="100px" prop="DocNo">
            <span style="display: inline-block; width: 180px" v-if="Mode == 0" class="detail-span">{{ data.DocNo }}</span>
            <el-input style="width: 180px" v-else v-model="data.DocNo" placeholder="请输入单据编码"></el-input>
          </el-form-item>
          <el-form-item label="业务类型:" label-width="100px">
            <span class="not-edit" style="width: 180px" v-if="Status === 2">{{ data.BusinessType }}</span>
            <!-- <business-select
              v-else
              v-model="data.BusinessTypeId"
              style="width: 190px"
            /> -->
            <el-select v-else v-model="data.BusinessTypeId" style="width: 180px">
              <el-option @click.native="BusinessChange(item)" v-for="item in businessTypeList" :key="item.BusinessTypeId" :label="item.BusinessType" :value="item.BusinessTypeId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户:" label-width="100px" prop="TradeUnitId">
            <span class="not-edit" v-if="Status === 2 || !editTrade">{{ data.TradeUnitName }}</span>
            <el-select v-else style="width: 180px" v-model="data.TradeUnitId" filterable>
              <el-option v-for="item in tradeUnitList" :key="item.key" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓库:" label-width="100px" prop="WarehouseId">
            <span class="not-edit" v-if="Status === 2">{{ data.WarehouseName }}</span>
            <el-select v-else style="width: 180px" v-model="data.WarehouseId" @change="changeWarehouseName">
              <el-option v-for="item in warehouse" :key="item.key" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经手人:" prop="EmpId">
            <span class="not-edit" v-if="Status === 2">{{ data.EmpName }}</span>
            <select-input v-else placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" style="width: 180px" />
          </el-form-item>
          <el-form-item label="制单人:" label-width="100px">
            <span class="span" style="width: 180px">{{ data.MakeEmpName }}</span>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注:" label-width="100px">
              <el-input type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" :disabled="Status === 2" style="width: 600px" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row style="padding: 10px">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="custom-tabs">
          <el-tab-pane label="明细" name="1">
            <el-table
              border
              class="table_bottom table-line tb-c-head"
              :data="tableData"
              stripe
              style="margin-top: 18px"
              :row-class-name="tableRowClassName"
              @row-click="add"
              v-keymove="newLine"
              v-if="showDetail"
            >
              <insert-row @on-insert="onInsert" />
              <el-table-column min-width="160" align="left" label="备注" v-if="showField('备注')">
                <template slot-scope="{ row }">
                  <span v-if="Status === 2">{{ row.Remark }}</span>
                  <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
                </template>
              </el-table-column>
              <el-table-column label="仓库" prop="WarehouseId" align="left" min-width="180" v-if="showField('仓库')">
                <template slot-scope="{ row }">
                  <span class="not-edit" v-if="Status === 2">{{ row.WarehouseName }}</span>
                  <el-select v-else style="width: 140px" v-model="row.WarehouseId" @change="changColunmeWarehouseName($event, row)">
                    <el-option v-for="item in warehouse" :key="item.key" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="存货名称" prop="ProductName" align="left" min-width="100" v-if="showField('存货名称')">
                <template slot-scope="{ row }">
                  <span class="not-edit" v-if="Status === 2">{{ row.ProductName }}</span>
                  <account-select
                    v-else
                    v-model="row.ProductName"
                    :source="DAccount"
                    @select="onSelect($event, row)"
                    :pageSize="pageParams.pageSize"
                    :pageIndex="pageParams.pageIndex"
                    :listTotal="listTotal"
                    @inputText="inputText($event, row)"
                    @click.native="resetFun"
                    @currentPage="currentPage($event, row)"
                    :pageType="true"
                  />
                </template>
              </el-table-column>
              <el-table-column label="存货条码" prop="Barcode" align="left" min-width="160" v-if="showField('存货条码')"> </el-table-column>
              <el-table-column align="left" label="批号" min-width="300px" v-if="showField('批号')">
                <template slot-scope="{ row, $index }">
                  <span v-if="!row.ProductName" style="color: #999">请先选择存货</span>
                  <span class="not-edit" v-else-if="Status === 2">{{ row.BatchNumber }}</span>
                  <span v-else-if="!row.IsBatchNumber" class="text-gray">该存货未启用批号</span>
                  <account-select
                    v-else
                    v-model="row.BatchNumber"
                    :Head="Head"
                    :source="batchList"
                    :listTotal="batchListTotal"
                    :pageType="true"
                    :pageSize="batchPageParams.pageSize"
                    :pageIndex="batchPageParams.pageIndex"
                    @select="onSelBatch($event, row, $index)"
                    @inputText="inputTextBatch($event, row)"
                    @click.native="onOpenBatch($event, row, $index)"
                    @currentPage="currentPageBatch($event, row)"
                    keyword="BatchNumber"
                  />
                </template>
              </el-table-column>
              <el-table-column label="存货编码" prop="ProductNo" align="left" min-width="160" v-if="showField('存货编码')"> </el-table-column>
              <el-table-column label="规格型号" prop="ProductSpec" align="left" min-width="100" v-if="showField('规格型号')"> </el-table-column>
              <el-table-column label="属性" prop="PropertyId" align="left" min-width="100" key="table1_6" v-if="showField('属性')">
                <template slot-scope="{ row }">
                  <el-select v-if="row.UseProcess && Status !== 2" v-model="row.PropertyId" @change="changeProperty($event, row)">
                    <el-option v-for="item in propertyList" :key="item.PropertyId" :label="item.PropertyName" :value="item.PropertyId"></el-option>
                  </el-select>
                  <span class="not-edit" v-else>{{ row.UseProcess ? row.PropertyName : '' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="颜色" prop="ColorId" align="left" min-width="100" key="table1_7" v-if="showField('颜色')">
                <template slot-scope="{ row }">
                  <el-select
                    v-if="(row.UseColor && Status !== 2 && (row.SourceId === 0 || row.SourceId == null)) || (row.UseColor && Status !== 2 && row.ColorId)"
                    v-model="row.ColorId"
                    @change="changeColor($event, row)"
                  >
                    <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId" :disabled="item.Status == 0"></el-option>
                  </el-select>
                  <span class="not-edit" v-else>{{ row.UseColor ? row.ColorName : '' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="装箱规格" prop="PackingSpeciId" align="left" min-width="100" v-if="showField('装箱规格')">
                <template slot-scope="{ row }">
                  <el-select v-model="row.PackingSpeciId" @change="changeSpeci($event, row)">
                    <el-option v-for="item in packingspeciList" :key="item.PackingSpeciId" :label="item.SpeciName" :value="item.PackingSpeciId" :disabled="item.Status == 0"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="每件数" prop="PackingNumber" align="left" min-width="100" v-if="showField('装箱数量')"></el-table-column>
              <el-table-column label="件数" prop="PackingQuantity" align="left" min-width="140" v-if="showField('件数')">
                <template slot-scope="{ row, $index }">
                  <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.PackingQuantity) }}</span>
                  <el-input type="text" class="input-with-select" style="width: 100px" v-else @change="changePackingQuantity($event, row, $index)" v-model="row.PackingQuantity">
                    <!-- <el-button v-if="row.ProductName" style="width: 40px; border-left: 1px" slot="append" @click="openSales(row, $index)" icon="el-icon-s-order"></el-button> -->
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column align="left" label="计量单位" min-width="120px" v-if="showField('计量单位')">
                <template slot-scope="{ row, $index }">
                  <el-select v-if="row.Units && row.Units.length > 0 && row.HasGrammage != true" v-model="row.UnitId" :disabled="Status === 2">
                    <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
                  </el-select>
                  <span v-else>{{ row.UnitName }}</span>
                </template>
                <!--  -->
              </el-table-column>
              <el-table-column label="应发数量" prop="ReQuantity" align="right" min-width="100" v-if="showField('应发数量')">
                <template slot-scope="{ row }">
                  <span class="not-edit">{{ $commonJs.toThousands(row.ReQuantity) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="实发数量" prop="Quantity" align="right" min-width="100" v-if="showField('实发数量')">
                <template slot-scope="{ row, $index }">
                  <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity) }}</span>
                  <el-input v-else type="text" v-model="row.Quantity" @change="changeQuantity($event, row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="单价" prop="Price" align="right" min-width="100" v-if="canPrice && showField('单价')">
                <template slot-scope="{ row }">
                  <span class="not-edit" v-if="Status === 2">{{ row.Price }}</span>
                  <el-input type="number" v-else v-model="row.Price" @change="changePrice($event, row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="金额" prop="Amount" align="right" min-width="100" v-if="canPrice && showField('金额')">
                <template slot-scope="{ row }">
                  <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Amount) }}</span>
                  <el-input type="number" v-else v-model="row.Amount" @change="changeAmount($event, row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="left" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
                <template slot-scope="{ row, $index }">
                  <!-- <span>{{ row }}{{ $index }}</span> -->
                  <el-select v-if="row.Units && row.Units.length > 0 && row.HasGrammage != true" v-model="row.UnitId2" :disabled="Status === 2">
                    <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
                  </el-select>
                  <span v-else-if="row.UnitType == 0"></span>
                  <span v-else>{{ row.UnitName2 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="应发数量2" prop="ReQuantity2" align="right" min-width="100" v-if="showField('应发数量2')">
                <template slot-scope="{ row }">
                  <span class="not-edit">{{ $commonJs.toThousands(row.ReQuantity2) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="实发数量2" prop="Quantity2" align="right" min-width="100" v-if="showField('实发数量2')">
                <template slot-scope="{ row, $index }">
                  <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity2) }}</span>
                  <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Quantity2" @change="changeQuantity2($event, row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="报价" prop="QuotedPrice" align="right" min-width="100" v-if="canPrice && showField('报价')"> </el-table-column>
              <el-table-column label="折扣率%" prop="Discount" align="right" min-width="100" v-if="canPrice && showField('折扣率%')"> </el-table-column>
              <el-table-column label="单价2" prop="Price2" align="right" min-width="100" v-if="canPrice && showField('单价2')">
                <template slot-scope="{ row }">
                  <span class="not-edit" v-if="Status === 2">{{ row.Price2 }}</span>
                  <el-input type="text" v-else v-model="row.Price2" @change="changePrice2($event, row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="克重" prop="Grammage" align="right" min-width="100" v-if="showField('克重')">
                <template slot-scope="{ row, $index }">
                  <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Grammage) }}</span>
                  <el-input type="text" v-else-if="row.HasGrammage == true" @change="changeGrammage($event, row, $index)" v-model="row.Grammage"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" label="换算率" v-if="showField('换算率')">
                <template slot-scope="{ row, $index }">
                  <span v-if="(Status === 2 || row.ChangeType == 0) && row.UnitType == 1">{{ row.Rate }}</span>
                  <span v-else-if="row.UnitType == 0"></span>
                  <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="来源单据" prop="SourceType" align="left" min-width="100" v-if="showField('来源单据')">
                <template slot-scope="{ row }">
                  <span v-if="row.SourceType === 6">销售订单</span>
                  <span v-if="row.SourceType === 7">发货通知单</span>
                  <span v-if="row.SourceType === 8">销货单</span>
                </template>
              </el-table-column>
              <el-table-column label="来源单号" prop="SourceNo" align="left" min-width="180" v-if="showField('来源单号')"> </el-table-column>
              <el-table-column label="销售订单号" prop="SaleOrderNo" align="left" min-width="100" v-if="showField('销售订单号')"> </el-table-column>
              <el-table-column label="赠品" prop="IsGift" align="center" min-width="100" v-if="showField('赠品')">
                <template slot-scope="{ row }">
                  <el-checkbox v-model="row.IsGift" :disabled="Status === 2"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="可用量" prop="AvailableQuantity" align="right" min-width="100" v-if="showField('可用量')">
                <template slot-scope="{ row }">
                  <span class="not-edit">{{ $commonJs.toThousands(row.AvailableQuantity) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="现存量" prop="ExistQuantity" align="right" min-width="100" v-if="showField('现存量')">
                <template slot-scope="{ row }">
                  <span class="not-edit">{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" align="center" min-width="140px" v-if="Status != 2">
                <template slot-scope="{ row, $index }">
                  <!-- <el-button type="text" @click="openSales(row, $index)" v-if="row.ProductId > 0" :disabled="Status===2">分箱</el-button> -->
                  <el-button type="text" @click="del(row, $index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table></el-tab-pane
          >
          <el-tab-pane label="汇总" name="2">
            <el-table border class="table_bottom table-line tb-c-head" :data="tableDataSummary" stripe style="margin-top: 18px" show-summary :summary-method="getSummaries">
              <el-table-column label="存货名称" prop="ProductName" align="left" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ row.ProductName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="存货编码" prop="ProductNo" align="left" min-width="160">
                <template slot-scope="{ row }">
                  <span>{{ row.ProductNo }}</span>
                </template>
              </el-table-column>
              <el-table-column label="件数" prop="PackingQuantity" align="right" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(row.PackingQuantity) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="计量单位" prop="UnitName" align="left" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ row.UnitName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" prop="Quantity" align="right" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" prop="UnitName2" label="计量单位2" min-width="120px">
                <template slot-scope="{ row }">
                  <span v-if="row.UnitType == 0"></span>
                  <span v-else>{{ row.UnitName2 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" label="数量2" prop="Quantity2" min-width="120px">
                <template slot-scope="{ row }">
                  <span v-if="row.UnitType == 0"></span>
                  <span v-else>{{ $commonJs.toThousands(row.Quantity2) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane></el-tabs
        ></el-row
      >
      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <sale-order-dialog ref="saleOrderDialog" in-dialog selectable multiple @select-multiple="setOrderList($event, '销售订单')" />
    <sale-dialog ref="saleDialog" in-dialog selectable multiple @select-multiple="setOrderList($event, '销货单')" :ordertype="ordertype" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
    <order-dialog ref="orderDialog" @save="initerPrice" in-dialog />
    <delivery-dialog ref="deliveryDialog" in-dialog selectable multiple @select-multiple="setOrderList($event, '发货通知单')" :ordertype="ordertype" />
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode'
import accountSelect from '@/components/business/stock/select'
import optionMixins from '@/mixins/option'
import empDialog from '@/components/personnel/result/record/listDialog'
import saleOrderDialog from '@/components/business/sales/saleorder/listDeliveryDialog'
import saleDialog from '@/components/business/sales/sale/listDialog'
import deliveryDialog from '@/components/business/sales/deliveryrelease/info/listDialog'
import fieldDialog from '@/components/common/fieldDialog'
import orderDialog from '@/components/business/sales/deliveryrelease/todo/priceDialog'

export default {
  name: 'editselloutwarehouse',
  mixins: [optionMixins],
  components: {
    accountSelect,
    VueBarcode,
    empDialog,
    saleOrderDialog,
    saleDialog,
    fieldDialog,
    orderDialog,
    deliveryDialog
  },
  data() {
    return {
      keepData: [],
      viewType: 'create',
      colorApi: require('@/api/ba/color').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      businessTypeApi: require('@/api/ba/businessType').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      code_api: require('@/api/sy/serialCode').default,
      api: require('@/api/stock/stOutDoc').default,
      pdApi: require('@/api/ba/product').default,
      propertyApi: require('@/api/ba/property').default,
      docSetting_api: require('@/api/sy/docSetting').default,
      packingspeciApi: require('@/api/ba/packingspeci').default,
      propertyList: [],
      Mode: 0,
      colors: [],
      warehouse: [],
      businessTypeList: [],
      tradeUnitList: [],
      Status: 0,
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      tableDataSummary: [
        {
          ProductNo: '',
          ProductName: '',
          UnitType: 0,
          UnitName: '',
          Quantity: null,
          Price: null,
          Amount: null,
          UnitName2: '',
          Price2: null,
          Quantity2: null,
          PackingQuantity: null
        }
      ],
      activeName: '1',
      ordertype: '销售出库单',
      title: '',
      bool: true,
      isSave: false,
      editTrade: true,
      data: {
        OutType: 0,
        DocId: 0,
        DocDate: this.$commonJs.getToday(),
        DocNo: '',
        MinusEntry: '',
        BusinessType: '',
        BusinessTypeId: null,
        BusinessTypeNo: '',
        TradeUnitId: null,
        TradeUnitName: '',
        WarehouseId: null,
        WarehouseName: '',
        EmpId: '',
        EmpName: '',
        MakeEmpName: '',
        MakeEmpId: 0,
        ReviewEmpName: '',
        ReviewEmpId: 0,
        ReviewTime: '',
        Remark: ''
      },
      date: [],
      tableData: [
        {
          T: 0,
          DocId: 0,
          DocProductId: 0,
          WarehouseId: null,
          WarehouseName: '',
          ProductNo: '',
          ProductName: '',
          ProductId: null,
          ColorId: null,
          ColorName: '',
          Colors: [],
          UnitName: '',
          UnitName2: '',
          UnitId: null,
          Units: [],
          Quantity: null,
          ReQuantity: null,
          Price: null,
          Amount: null,
          UnitId2: null,
          UnitNmae2: '',
          PropertyId: null,
          PropertyName: '',
          Quantity2: null,
          ReQuantity2: null,
          QuotedPrice: null,
          Discount: null,
          Price2: null,
          Rate: null,
          SourceDocId: 0,
          SourceDocType: '',
          SourceDocNo: '',
          IsGift: false,
          AvailableQuantity: null,
          ExistQuantity: null,
          SaleOrderNo: '',
          Remark: '',
          BatchNumber: '',
          Grammage: null
        }
      ],
      delTableData: [],
      rules: {
        DocDate: [{ required: true, message: '单据日期不能为空' }],
        DocNo: [{ required: true, message: '单据编码不能为空' }],
        BusinessTypeId: [{ required: true, message: '业务类型不能为空', trigger: 'change' }],
        TradeUnitId: [{ required: true, message: '客户不能为空', trigger: 'change' }],
        WarehouseId: [{ required: true, message: '仓库不能为空', trigger: 'change' }],
        EmpId: [{ required: true, message: '经手人不能为空' }]
      },
      detailFields: [],
      showDetail: false,
      Head: [
        { Value: 'BatchNumber', Name: '批号', Width: '180' },
        { Value: 'WarehouseName', Name: '仓库', Width: '100' },
        { Value: 'ColorName', Name: '颜色', Width: '80' },
        { Value: 'PropertyName', Name: '属性', Width: '80' },
        // { Value: "BatchStartDate", Name: "批次起始日期", Width: "100" },
        // { Value: "ExpireDate", Name: "有效期至", Width: "100" },
        { Value: 'BaseUnitName', Name: '主单位', Width: '80' },
        { Value: 'BaseQuantity', Name: '现存量', Width: '80' },
        { Value: 'SubUnitName', Name: '辅单位', Width: '80' },
        { Value: 'SubQuantity', Name: '现存量', Width: '80' }
      ],
      batchListTotal: 0,
      batchPageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      batchList: [],
      packingspeciList: []
    }
  },
  mounted() {
    this.viewType = this.$route.params.type

    if (this.$route.params.type === 'create') {
      this.getPreviewNo()
    } else if (this.$route.params.type === 'edit') {
      this.editInit(this.$route.params.data)
    }
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/selloutwarehouse')
    },
    canWrite() {
      return this.$permission.canWrite('/business/stock/selloutwarehouse')
    },
    canReview() {
      return this.$permission.canReview('/business/stock/selloutwarehouse')
    }
  },
  created() {
    this.init()
  },
  methods: {
    handleClick(tab, event) {
      if (this.activeName == '2') {
        this.tableDataSummary = this.summarizeTableData()
        console.log(this.tableDataSummary)
      }
    },
    summarizeTableData() {
      const summary = {}
      // 遍历所有产品，进行汇总
      console.log('this.tableList', this.tableData)
      this.tableData.forEach(product => {
        if (product.ProductNo) {
          if (!summary[product.ProductNo]) {
            // 如果是第一次遇到该产品，则初始化
            summary[product.ProductNo] = {
              ProductNo: product.ProductNo,
              ProductName: product.ProductName,
              UnitType: product.UnitType,
              UnitName: product.UnitName,
              UnitName2: product.UnitName2,
              Quantity: product.Quantity,
              Quantity2: product.UnitType == 1 ? product.Quantity2 : 0,
              PackingQuantity: product.PackingQuantity,
              count: 1
            }
          } else {
            // 否则，累加数量和总价，并增加计数
            if (product.UnitType == 1 && summary[product.ProductNo].UnitName != product.UnitName) {
              summary[product.ProductNo].Quantity += product.Quantity
              summary[product.ProductNo].Quantity2 += product.Quantity2
            } else {
              summary[product.ProductNo].Quantity += product.Quantity
              if (product.UnitType == 1) summary[product.ProductNo].Quantity2 += product.Quantity2
            }
            summary[product.ProductNo].PackingQuantity += product.PackingQuantity
            summary[product.ProductNo].count++
          }
        }
      })

      // 将汇总结果转换为数组，并计算平均单价
      return Object.values(summary).map(sum => ({
        ProductNo: sum.ProductNo,
        ProductName: sum.ProductName,
        UnitType: sum.UnitType,
        UnitName: sum.UnitName,
        UnitName2: sum.UnitName2,
        Quantity: sum.Quantity,
        Quantity2: sum.Quantity2,
        PackingQuantity: sum.PackingQuantity
      }))
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      const fieldNames = columns.map(col => col.property)
      fieldNames.forEach((field, index) => {
        if (field && ['Quantity', 'Quantity2', 'PackingQuantity'].includes(field)) {
          const values = data.map(item => Number(item[field]))
          console.log('values', values)
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            //金额 固定2位小数
            const arr2 = ['Amount']
            var v = sums[index]
            if (arr2.indexOf(field.property) != -1) {
              v = v.toFixed(2)
              let vStr = v.toString().split('.')
              if (Number(vStr[1]) <= 0) v = vStr[0]
            }
            if (v > 0) {
              v = Number(v).toLocaleString()
            }
            sums[index] = v
          } else {
            sums[index] = '-'
          }
        } else {
          sums[index] = ''
        }
      })
      sums[0] = '合计'
      return sums
    },
    //单据保存回显
    initerPrice(data) {
      console.log(data, 'initerPrice')
      if (data) {
        console.log(data, 'saved')

        this.tableData.splice(data.index, 1)
        console.log(this.tableData, 'this.tableData')
        var arr = []
        data.list.forEach(item => {
          let o = {
            ...item,
            PropertyId: item.PropertyId
          }
          console.log(o, 'separate')
          arr.push(o)
        })
        this.tableData.unshift(...arr)

        this.tableData.forEach((i, d) => {
          i.index = d
        })
      }
    },
    openSales(row, index) {
      this.currentRow = row
      this.currentIndex = index
      let o = { ...row, index }
      this.$refs.orderDialog.openEdit(o)
      // this.$refs.orderDialog.open();
    },
    changePackingQuantity(val, row, index) {
      if (row.PackingNumber > 0) {
        if (val) {
          row.Quantity = parseInt(val * row.PackingNumber)
          if (row.HasGrammage == true) {
            row.Quantity2 = row.Quantity * row.Rate
          }
        }
      }
    },
    changeSpeci(val, row) {
      let item = this.packingspeciList.filter(item => {
        return item.PackingSpeciId === val
      })[0]
      console.log(item, 'changeSpeci')
      if (item) {
        row.PackingNumber = item.PackingNumber
        row.RealPackingNumber = item.PackingNumber
        if (row.Quantity) {
          row.PackingQuantity = parseInt(row.Quantity / row.PackingNumber)
        }
      }
    },
    //更改克重
    changeGrammage(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') return
      console.log('row', row)
      this.editT(row)
      if (row.UnitType == 1) {
        if (row.HasGrammage == true) {
          row.Rate = Number((row.Grammage / row.Variable).toFixed(5))
          if (row.IsMain) {
            row.Quantity2 = this.getQuantity(row.Quantity * Number(row.Rate))
            console.log('row.IsMain1', row.IsMain, Number(row.Rate))
            if (type === 0) {
              row.Amount = this.setAmount(row.Price, row.Quantity)
            }
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
            console.log('row.IsMain2', row.IsMain, Number(row.Rate))
          }
        }
      }
    },
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: '销售出库单', Url: 'business/stock/selloutwarehouse/edit' })
      })
    },
    setTbField() {
      this.showDetail = false
      this.docSetting_api.list({ DocType: '销售出库单', IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey)
          this.$nextTick(() => {
            this.showDetail = true
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1
    },
    onInsert(e) {
      let { type, index } = e
      this.interpolate(null, index, type)
    },
    async goJump(index) {
      let params = {}
      let ids = []
      let res = null
      switch (index) {
        case 1:
          res = await this.sourceTypeApi.info('销售订单')
          params.SourceType = res.SourceTypeId
          ids = this.tableData
            .filter(item => {
              return item.SourceType === res.SourceTypeId
            })
            .map(item => {
              return item.SourceId
            })
          if (ids.length === 0) {
            this.$message.error('单据未引用销售订单，无法进行联查')
          } else {
            params.Ids = ids
            this.$router.push({ name: 'saleorder', params: params })
          }

          break
        case 2:
          res = await this.sourceTypeApi.info('销货单')
          params.OrderType = res.SourceTypeId
          ids = this.tableData
            .filter(item => {
              return item.SourceType === res.SourceTypeId
            })
            .map(item => {
              return item.SourceId
            })
          if (ids.length === 0) {
            this.$message.error('单据未引用销货单，无法进行联查')
          } else {
            params.Ids = ids
            this.$router.push({ name: 'sale', params: params })
          }

          break
      }
    },
    interpolate(row, index, type = '') {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        WarehouseId: null,
        WarehouseName: '',
        ProductNo: '',
        ProductName: '',
        ProductId: null,
        ColorId: null,
        ColorName: '',
        Colors: [],
        UnitName: '',
        UnitName2: '',
        UnitId: null,
        Units: [],
        Quantity: null,
        ReQuantity: null,
        Price: null,
        Amount: null,
        UnitId2: null,
        UnitNmae2: '',
        Quantity2: '',
        ReQuantity2: '',
        QuotedPrice: null,
        Discount: null,
        Price2: null,
        Rate: null,
        SourceId: 0,
        SourceType: 0,
        SourceDtsId: 0,
        SourceNo: '',
        IsGift: false,
        AvailableQuantity: null,
        ExistQuantity: null,
        SaleOrderNo: '',
        PropertyId: null,
        PropertyName: ''
      }

      if (type == 'down') {
        index = index + 1
      }
      this.tableData.splice(index, 0, o)
      let copy = JSON.parse(JSON.stringify(this.tableData))
      this.tableData = []
      this.$nextTick(() => {
        this.tableData = copy
      })
      console.log('this.tableData', this.tableData)
    },
    async setOrderList(data, type) {
      if (type === '销货单') {
        console.log('data 销货单', data)
        const res = await this.sourceTypeApi.info('销货单')
        let SourceType = res.SourceTypeId
        let arr = []
        this.data.TradeUnitId = data.TradeUnitId || null
        this.data.TradeUnitName = data.FullName
        this.data.WarehouseId = data.WarehouseId
        this.data.WarehouseName = data.WarehouseName

        if (data.TradeUnitId) this.editTrade = false
        data.List.forEach(item => {
          let o = {
            T: 0,
            DocId: 0,
            DocProductId: 0,
            WarehouseId: this.data.WarehouseId,
            WarehouseName: this.data.WarehouseName,
            ProductNo: item.ProductNo,
            ProductName: item.ProductName,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            ColorName: item.ColorName,
            UseColor: item.UseColor,
            UseProcess: item.UseProcess,
            Colors: item.Colors,
            UnitName: item.SaUnitName,
            UnitName2: item.UnitName,
            UnitId: item.SaUnitId,
            UnitId2: item.UnitId2,
            Units: item.Units,
            Quantity: item.SaQuantity,
            ReQuantity: item.SaQuantity,
            Price: item.Price,
            Amount: item.Amount,
            PropertyId: null,
            PropertyName: '',
            Quantity2: item.Quantity2,
            ReQuantity2: item.Quantity2,
            QuotedPrice: item.QuotedPrice,
            Discount: item.Discount,
            Price2: item.Price2 || 0,
            Rate: item.Rate,
            SourceId: item.DocId,
            SourceType,
            SourceDtsId: item.DocProductId,
            SourceNo: data.Order,
            IsGift: item.IsGift,
            AvailableQuantity: 0,
            ExistQuantity: 0,
            SaleOrderNo: '',
            Grammage: item.Grammage,
            BatchNumber: item.BatchNumber,
            HasGrammage: item.HasGrammage,
            Variable: item.Variable,
            Barcode: item.BarCode ?? '',
            PackingQuantity: item.PackingQuantity,
            PackingNumber: item.PackingNumber,
            RealPackingNumber: item.RealPackingNumber,
            PackingSpeciId: item.PackingSpeciId
          }
          console.log('===o====', o)
          arr.push(o)
        })

        arr.forEach((item, i) => {
          item.IsBatchNumber = item.BatchNumber ? true : false
          item.isSource = item.SourceId === 0 || item.SourceId == null ? false : true
          if (item.Barcode === '' || item.Barcode == null) {
            var colorNo = '0'
            var propertyNo = '0'
            if (item.ColorId > 0) {
              var color = item.Colors.find(x => x.ColorId == item.ColorId)
              if (color) {
                colorNo = color.ColorNo
              }
            }
            if (item.PropertyId > 0) {
              var property = this.propertyList.find(x => x.PropertyId == item.PropertyId)
              if (property) {
                propertyNo = property.PropertyNo
              }
            }
            item.Barcode = item.ProductNo + '*' + colorNo + '*' + propertyNo
          }
          item.ChangeType = 0
          // item.Units.forEach(v=>{
          //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
          // })
          if (item.Units.length > 0 && item.UnitId) {
            const findIndex = item.Units.findIndex(el => el.UnitId == item.UnitId)
            const IsMainIndex = item.Units.findIndex(el => el.IsMain == true) //主单位的索引
            const UnitId2Index = item.Units.findIndex(el => el.UnitId == item.UnitId2) //不是主单位的索引
            const noMainIndex = item.Units.findIndex(el => el.IsMain == false)
            if (findIndex == IsMainIndex) {
              //判断当前销售单位是否为主单位
              item.Rate = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].Rate || 0
              item.ChangeType = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].ChangeType || 0
              item.IsMain = true
            } else {
              item.IsMain = false
              //如果当前是赋单位
              item.Rate = item.Units[findIndex].Rate
              item.ChangeType = item.Units[findIndex].ChangeType
            }
            console.log('====item====', item)
          } else {
            item.Units.forEach(v => {
              if (v.ChangeType == 1) item.ChangeType = v.ChangeType
            })
          }
        })

        this.tableData.unshift(...arr)
      } else if (type === '发货通知单') {
        console.log('data 发货通知单', data)
        const res = await this.sourceTypeApi.info('发货通知单')
        let SourceType = res.SourceTypeId
        let arr = []
        this.data.TradeUnitId = data.TradeUnitId || null
        this.data.TradeUnitName = data.FullName
        this.data.WarehouseId = data.WarehouseId
        this.data.WarehouseName = data.WarehouseName

        if (data.TradeUnitId) this.editTrade = false
        data.List.forEach(item => {
          let o = {
            T: 0,
            DocId: 0,
            DocProductId: 0,
            WarehouseId: this.data.WarehouseId,
            WarehouseName: this.data.WarehouseName,
            ProductNo: item.ProductNo,
            ProductName: item.ProductName,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            ColorName: item.ColorName,
            UseColor: item.UseColor,
            UseProcess: item.UseProcess,
            Colors: item.Colors,
            UnitName: item.SaUnitName,
            UnitName2: item.UnitName2,
            UnitId: item.SaUnitId,
            UnitId2: item.UnitId2,
            Units: item.Units,
            Quantity: item.RealQuantity,
            ReQuantity: item.RealQuantity,
            Price: item.Price,
            Amount: item.Amount,
            PropertyId: item.PropertyId,
            PropertyName: item.PropertyName,
            Quantity2: item.RealQuantity2,
            ReQuantity2: item.RealQuantity2,
            QuotedPrice: item.QuotedPrice,
            Discount: item.Discount,
            Price2: item.Price2 ,
            Rate: item.Rate,
            SourceId: item.DeliveryDocId,
            SourceType,
            SourceDtsId: item.DeliveryDocProductId,
            SourceNo: data.Order,
            IsGift: item.IsGift,
            AvailableQuantity: 0,
            ExistQuantity: 0,
            SaleOrderNo: item.OrderNo,
            Grammage: item.Grammage,
            BatchNumber: item.BatchNumber,
            HasGrammage: item.HasGrammage,
            Variable: item.Variable,
            Barcode: item.BarCode ?? '',
            PackingQuantity: item.PackingQuantity,
            PackingNumber: item.PackingNumber,
            RealPackingNumber: item.RealPackingNumber,
            PackingSpeciId: item.PackingSpeciId
          }
          console.log('===o====', o)
          arr.push(o)
        })

        arr.forEach((item, i) => {
          item.IsBatchNumber = item.BatchNumber ? true : false
          item.isSource = item.SourceId === 0 || item.SourceId == null ? false : true
          if (item.Barcode === '' || item.Barcode == null) {
            var colorNo = '0'
            var propertyNo = '0'
            if (item.ColorId > 0) {
              var color = item.Colors.find(x => x.ColorId == item.ColorId)
              if (color) {
                colorNo = color.ColorNo
              }
            }
            if (item.PropertyId > 0) {
              var property = this.propertyList.find(x => x.PropertyId == item.PropertyId)
              if (property) {
                propertyNo = property.PropertyNo
              }
            }
            item.Barcode = item.ProductNo + '*' + colorNo + '*' + propertyNo
          }
          item.ChangeType = 0
          // item.Units.forEach(v=>{
          //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
          // })
          if (item.Units.length > 0 && item.UnitId) {
            const findIndex = item.Units.findIndex(el => el.UnitId == item.UnitId)
            const IsMainIndex = item.Units.findIndex(el => el.IsMain == true) //主单位的索引
            const UnitId2Index = item.Units.findIndex(el => el.UnitId == item.UnitId2) //不是主单位的索引
            const noMainIndex = item.Units.findIndex(el => el.IsMain == false)
            if (findIndex == IsMainIndex) {
              //判断当前销售单位是否为主单位
              item.Rate = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].Rate || 0
              item.ChangeType = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].ChangeType || 0
              item.IsMain = true
            } else {
              item.IsMain = false
              //如果当前是赋单位
              item.Rate = item.Units[findIndex].Rate
              item.ChangeType = item.Units[findIndex].ChangeType
            }
            console.log('====item====', item)
          } else {
            item.Units.forEach(v => {
              if (v.ChangeType == 1) item.ChangeType = v.ChangeType
            })
          }
        })

        this.tableData.unshift(...arr)
      } else {
        console.log('data', data)
        const res = await this.sourceTypeApi.info('销售订单')
        let SourceType = res.SourceTypeId

        let arr = []

        this.data.TradeUnitId = data.TradeUnitId || null
        this.data.TradeUnitName = data.FullName
        if (data.TradeUnitId) this.editTrade = false
        // this.data.TradeUnitId = data.TradeUnitId||null;
        data.List.forEach(item => {
          item.PackInfos.forEach(x => {
            let o = {
              T: 0,
              DocId: 0,
              DocProductId: 0,
              WarehouseId: this.data.WarehouseId,
              WarehouseName: this.data.WarehouseName,
              ProductNo: item.ProductNo,
              ProductName: item.ProductName,
              ProductId: item.ProductId,
              ColorId: item.ColorId,
              ColorName: item.ColorName,
              Colors: item.Colors,
              UnitName: item.SaUnitName,
              UnitName2: item.UnitName2 || '',
              UnitId: item.SaUnitId,
              UnitId2: item.UnitId2 || null,
              Units: item.Units,
              Quantity: item.SaQuantity,
              Quantity2: item.Quantity2,
              Price: item.Price,
              Amount: item.Amount,
              PropertyId: null,
              PropertyName: '',
              ReQuantity: item.SaQuantity,
              ReQuantity2: item.Quantity2,
              QuotedPrice: item.QuotedPrice,
              Discount: item.Discount,
              Price2: item.Price2 || 0,
              Rate: item.Rate,
              SourceId: item.OrderId,
              UseColor: item.UseColor,
              UseProcess: item.UseProcess,
              SourceType,
              SourceDtsId: item.OrderProductId,
              SourceNo: data.Order,
              IsGift: item.IsGift,
              AvailableQuantity: 0,
              ExistQuantity: 0,
              //SaleOrderNo: data.Order,
              // ChangeType: ChangeType,
              // ChangeType2: ChangeType2,
              SaleOrderNo: data.Order,
              Grammage: item.Grammage,
              BatchNumber: item.BatchNumber,
              HasGrammage: item.HasGrammage,
              Variable: item.Variable,
              PackingQuantity: x.PackingQuantity,
              PackingNumber: x.PackingNumber,
              RealPackingNumber: x.RealPackingNumber,
              Quantity: x.RealQuantity,
              Quantity2: x.RealQuantity2,
              PackingSpeciId: x.PackingSpeciId,
              PropertyId: x.PropertyId || null,
              ColorId: x.ColorId || null,
              Barcode: x.BarCode,
              SpeciName: x.SpeciName
            }
            arr.push(o)
          })
        })

        arr.forEach((item, i) => {
          item.IsBatchNumber = item.BatchNumber ? true : false
          item.isSource = item.SourceId === 0 || item.SourceId == null ? false : true
          if (item.Barcode === '' || item.Barcode == null) {
            var colorNo = '0'
            var propertyNo = '0'
            if (item.ColorId > 0) {
              var color = item.Colors.find(x => x.ColorId == item.ColorId)
              if (color) {
                colorNo = color.ColorNo
              }
            }
            if (item.PropertyId > 0) {
              var property = this.propertyList.find(x => x.PropertyId == item.PropertyId)
              if (property) {
                propertyNo = property.PropertyNo
              }
            }
            item.Barcode = item.ProductNo + '*' + colorNo + '*' + propertyNo
          }
          item.ChangeType = 0
          // item.Units.forEach(v=>{
          //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
          // })
          if (item.Units.length > 0 && item.UnitId) {
            const findIndex = item.Units.findIndex(el => el.UnitId == item.UnitId)
            const IsMainIndex = item.Units.findIndex(el => el.IsMain == true) //主单位的索引
            const UnitId2Index = item.Units.findIndex(el => el.UnitId == item.UnitId2) //不是主单位的索引
            const noMainIndex = item.Units.findIndex(el => el.IsMain == false)
            if (findIndex == IsMainIndex) {
              //判断当前销售单位是否为主单位
              item.Rate = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].Rate || 0
              item.ChangeType = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].ChangeType || 0
              item.IsMain = true
            } else {
              item.IsMain = false
              //如果当前是赋单位
              item.Rate = item.Units[findIndex].Rate
              item.ChangeType = item.Units[findIndex].ChangeType
            }
            console.log('====item====', item)
          } else {
            item.Units.forEach(v => {
              if (v.ChangeType == 1) item.ChangeType = v.ChangeType
            })
          }
        })

        this.tableData.unshift(...arr)
      }
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1

      this.editT(row)

      let lastIsMain = row.IsMain
      if (data.IsMain) {
        this.tableData[index].IsMain = false
      } else {
        this.tableData[index].IsMain = true
      }
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          //  row.ChangeType2 = data.ChangeType;
        }
      } else {
        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          //  row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex, data.Rate)
          // row.ChangeType2 = data.ChangeType;
          if (!lastIsMain) {
            row.Quantity = row.Quantity2
          }
          // row.Quantity2 = (row.Quantity / Number(data.Rate)).toFixed(2);
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data.Rate))
        }
      }
      this.changeQuantity2(this.tableData[index].Quantity2, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val)

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val)

      if (row.ReQuantity && row.ReQuantity2) {
        row.ReQuantity = row.Quantity
        row.ReQuantity2 = row.Quantity2
      }
    },
    changeQuantity(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)

      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2
        data = data > 0 ? 0 - data : data
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (row.T == 3) this.tableData[index].T = 1
      if (row.Units.length > 0) {
        if (row.IsMain) {
          // row.Quantity2= (row.Quantity / Number(row.Rate)).toFixed(2);
          //row.Quantity2 = this.getQuantity((row.Quantity / Number(row.Rate)))
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.Quantity * Number(row.Rate))
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity)
          }
        } else {
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.Quantity / row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity * row.Rate)
          }
          //row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity)
          }
          // if(row.ChangeType1 == 1 && row.Quantity2 != 0){
          //   row.Rate= Math.abs(Number(row.Quantity2/data)).toFixed(2);
          //   if(type === 0){
          //     let val = this.setNumber(Math.abs(row.Amount / data))
          //     row.Price = this.getPrice(val);
          //   }
          // }else if(row.Quantity2 == 0){
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(2);
          //   row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
          //   if(type === 0){
          //     row.Amount = this.setAmount(row.Price, row.Quantity);
          //   }
          // }else if(row.ChangeType1 == 0 ){
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(2);
          //   row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
          //   if(type === 0){
          //     row.Amount = this.setAmount(row.Price, row.Quantity);
          //   }
          // }
        }
      } else {
        row.Quantity2 = 0
        row.Amount = this.setAmount(row.Price, row.Quantity)
      }
    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1

      this.editT(row)

      console.log('json row', JSON.parse(JSON.stringify(row)))

      let lastIsMain = row.IsMain
      this.tableData[index].IsMain = data.IsMain
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex, data.Rate)
          // row.ChangeType1 = data.ChangeType;
          if (lastIsMain) {
            row.Quantity2 = row.Quantity
          }
          // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(2);
          row.Quantity = this.getQuantity(row.Quantity2 / Number(data.Rate))
        }
      }
      this.changeQuantity(this.tableData[index].Quantity, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val)

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val)

      if (row.ReQuantity && row.ReQuantity2) {
        row.ReQuantity = row.Quantity
        row.ReQuantity2 = row.Quantity2
      }
      console.log('row', row)
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    init() {
      const user = this.$store.state.user
      if (user) {
        this.data.EmpId = user.empId
        this.data.EmpName = user.name
      }

      this.packingspeciApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.packingspeciList = res.Data
        }
      })
      this.propertyApi
        .list({
          Status: 1
        })
        .then(res => {
          if (res.Code === 0) {
            this.propertyList = res.Data
          }
        })

      this.pdApi
        .list({
          PageIndex: this.pageParams.pageIndex,
          PageSize: this.pageParams.pageSize,
          Property: '销售',
          Status: 1
        })
        .then(res => {
          this.DAccount = res.Data
          this.initDAccount = res.Data
          this.listTotal = res.Count
          this.initTotal = res.Count
        })

      this.warehouseApi.list({ Status: 1, WarehouseType: 1 }).then(res => {
        if (res.Code === 0) {
          if (this.viewType !== 'edit') {
            this.data.WarehouseId = res.Data[0].WarehouseId
            this.data.WarehouseName = res.Data[0].WarehouseName
          }
          this.warehouse = res.Data.map(item => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId
            }
          })
        }
      })

      this.sourceTypeApi.list({}).then(res => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data
          let params = '销售出库单'
          let index = this.SourceTypeIdArr.findIndex(item => item.SourceType == params)
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId
          this.data.OutType = SourceTypeId
          this.businessTypeApi.getSourceTypeToBusinessType(SourceTypeId).then(res => {
            if (res.Code == 0) {
              this.businessTypeList = res.Data
              if (this.viewType !== 'edit') {
                this.data.BusinessTypeId = this.businessTypeList[0].BusinessTypeId
                this.data.BusinessType = this.businessTypeList[0].BusinessType
                this.data.MinusEntry = this.businessTypeList[0].MinusEntry
                this.changeNumber(this.data.MinusEntry)
              } else {
                console.log('this.data.BusinessTypeId', this.data.BusinessTypeId)
                let item = this.businessTypeList.filter(item => {
                  return item.BusinessTypeId === this.data.BusinessTypeId
                })[0]

                this.data.MinusEntry = item.MinusEntry

                this.changeNumber(this.data.MinusEntry)
              }
            }
          })
        }
      })

      this.tradeUnitApi.list({ TradeUnitTypes: [0, 2], Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.tradeUnitList = res.Data.map(item => {
            return {
              key: item.TradeUnitId,
              label: item.FullName,
              value: item.TradeUnitId
            }
          })
        }
      })

      this.callOptionApi()
      this.setTbField()
    },
    editInit(data, type = 'edit') {
      this.viewType = 'edit'
      this.isSave = true
      let {
        OutType,
        DocId,
        DocDate,
        DocNo,
        BusinessType,
        BusinessTypeId,
        BusinessTypeNo,
        TradeUnitId,
        TradeUnitName,
        WarehouseId,
        WarehouseName,
        EmpId,
        Status,
        EmpName,
        MakeEmpName,
        MakeEmpId,
        ReviewEmpName,
        ReviewEmpId,
        ReviewTime,
        Remark,
        Products
      } = data

      this.Status = Status

      this.data = {
        OutType,
        DocId,
        DocDate,
        DocNo,
        BusinessType,
        BusinessTypeId,
        BusinessTypeNo,
        TradeUnitId,
        TradeUnitName,
        WarehouseId,
        WarehouseName,
        EmpId,
        EmpName,
        MakeEmpName,
        MakeEmpId,
        ReviewEmpName,
        ReviewEmpId,
        ReviewTime,
        Remark
      }

      Products = this.initProducts(Products, type)
      console.log(Products, ' Products')

      this.tableData = Products
    },
    initProducts(Products, type) {
      Products.forEach((item, index) => {
        item.T = null
        item.IsBatchNumber = item.BatchNumber ? true : false
        item.ColorId = item.ColorId !== 0 ? item.ColorId : null
        item.PropertyId = item.PropertyId !== 0 ? item.PropertyId : null
        item.WarehouseId = item.WarehouseId !== 0 ? item.WarehouseId : null

        item.isSource = item.SourceId === 0 || item.SourceId == null ? false : true

        if (item.Units.length === 0 || item.Units == null) {
          item.UnitType = 0
        } else {
          item.UnitType = 1
          let UnitItem = item.Units.filter(v => {
            return item.UnitId === v.UnitId
          })[0]
          item.IsMain = UnitItem.IsMain

          item.Units.forEach(v => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType
          })
        }
        if (type == 'keep') {
          item.ChangeType = this.keepData[index].ChangeType
        }
      })

      return Products
    },
    BusinessChange(val) {
      this.data.BusinessTypeId = val.BusinessTypeId
      this.data.MinusEntry = val.MinusEntry
      this.data.BusinessType = val.BusinessType
      this.changeNumber(this.data.MinusEntry)
    },
    changeNumber(status) {
      if (status) {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity
          item.Quantity2 = item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity, item.Price)

          if (item.T !== 0) {
            item.T = 1
          }
        })
      } else {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity == null ? item.Quantity : Math.abs(item.Quantity)
          item.Quantity2 = item.Quantity2 == null ? item.Quantity2 : Math.abs(item.Quantity2)
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity, item.Price)

          if (item.T !== 0) {
            item.T = 1
          }
        })
      }
    },
    getPreviewNo(dateTime = '') {
      this.code_api.previewNo('销售出库单', dateTime).then(res => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.DocNo = res.Data.PreviewNo
        } else {
          this.$message.warning('获取销售出库单编号失败')
        }
      })
    },
    setEmp(data) {
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
    },
    openEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    changeBusinessType(val) {
      let item = this.businessTypeList.filter(item => {
        return val === item.BusinessTypeId
      })[0]

      this.data.BusinessTypeId = item.BusinessTypeId
      this.data.BusinessTypeNo = item.BusinessTypeNo
      this.data.BusinessType = item.BusinessType
    },
    changeWarehouseName(val) {
      let item = this.warehouse.filter(item => {
        return val === item.value
      })[0]
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].T !== 0) {
          this.tableData[i].T = 1
        }
        ;(this.tableData[i].WarehouseId = this.data.WarehouseId), (this.tableData[i].WarehouseName = this.data.WarehouseName)
      }
      this.data.WarehouseId = item.value
      this.data.WarehouseName = item.label
    },
    changColunmeWarehouseName(val, row) {
      let item = this.warehouse.filter(item => {
        return val === item.value
      })[0]

      this.editT(row)
      row.WarehouseId = item.value
      row.WarehouseName = item.label
    },
    changePrice(val, row) {
      this.editT(row)

      val = this.setNumber(val)
      row.Price = this.getPrice(val)
      row.Amount = this.setAmount(row.Price, row.Quantity)

      if (row.UnitId2 && row.Quantity2 !== 0) {
        row.Price2 = this.getPrice(row.Amount / row.Quantity2)
      }
    },
    changePrice2(val, row) {
      this.editT(row)

      val = this.setNumber(val)
      row.Price2 = this.getPrice(val)

      row.Amount = this.setAmount(row.Price2, row.Quantity2)
      if (row.Quantity !== 0) {
        row.Price = this.getPrice(row.Amount / row.Quantity)
      }
    },
    changeAmount(val, row) {
      this.editT(row)

      if (this.data.MinusEntry) {
        val = val > 0 ? 0 - val : val
      } else {
        val = Math.abs(val)
      }
      row.Amount = this.setNumber(val)

      if (row.Quantity !== 0) {
        row.Price = this.getPrice(Math.abs(row.Amount / row.Quantity))
      } else {
        this.$message({ type: 'warning', message: '实收数量不能为0' })
        row.Amount = 0
        return
      }

      if (row.Quantity2 !== 0) {
        row.Price2 = this.getPrice(Math.abs(row.Amount / row.Quantity2))
      } else {
        this.$message({ type: 'warning', message: '实收数量2不能为0' })
        row.Amount = 0
        return
      }
    },
    changeColor(val, row) {
      this.editT(row)

      let item = row.Colors.filter(item => {
        return item.ColorId === val
      })[0]

      row.ColorNo = item.ColorNo
      row.ColorName = item.ColorName
      if (row.ProductId > 0) {
        row.Barcode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
      }
    },
    changeProperty(val, row) {
      this.editT(row)

      let item = this.propertyList.filter(item => {
        return item.PropertyId === val
      })[0]

      row.PropertyNo = item.PropertyNo
      row.PropertyName = item.PropertyName
      if (row.ProductId > 0) {
        row.Barcode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
      }
    },
    setAmount(p, q) {
      return Number((p * q).toFixed(2))
    },
    changeUnitId2(val, row) {
      this.editT(row)

      let item = row.Units2.filter(item => {
        return item.UnitId === val
      })[0]

      row.UnitId2 = item.UnitId
      row.UnitName2 = item.UnitName

      row.Rate2 = item.Rate
      row.ChangeType2 = item.ChangeType

      row.Rate = row.Rate1 / row.Rate2
    },
    //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId2 = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].UnitName2 = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType2=this.tableData[index].Units[findIndex].ChangeType

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)
      // if(this.data.MinusEntry){
      //       row.Quantity2=0-row.Quantity2
      //      }else{
      //       row.Quantity2=Math.abs(row.Quantity2)
      //      }
      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2
        data = data > 0 ? 0 - data : data
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (row.T === 3) row.T = 1
      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          //row.Rate = Math.abs(Number(data / row.Quantity)).toFixed(2);
          if (row.HasGrammage == true) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(data / row.Quantity)
          }
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data))
            row.Price2 = this.getPrice(val)
          }
        } else {
          console.log('数量1=数量2/换算率')
          // row.Quantity=Number(data/row.Rate).toFixed(2);

          if (row.Quantity === 0) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Quantity = this.getQuantity(data / row.Rate)
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2)
          }
        }
      } else {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          //row.Rate = Math.abs(Number(row.Quantity / data)).toFixed(2);
          if (row.HasGrammage == true) {
            row.Quantity = this.getQuantity(data / row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(row.Quantity / data)
          }
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data))
            row.Price2 = this.getPrice(val)
          }
        } else {
          console.log('数量1=数量2*换算率')
          // row.Quantity=Number(data*row.Rate).toFixed(2);
          row.Quantity = this.getQuantity(data * row.Rate)
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2)
          }
        }
      }
    },
    getUnitValue(arr, findIndex) {
      let data = {}
      data.UnitId = arr[findIndex].UnitId
      data.UnitName = arr[findIndex].UnitName
      data.IsMain = arr[findIndex].IsMain
      data.ChangeType = arr[findIndex].ChangeType
      data.Rate = arr[findIndex].Rate
      return data
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = '') {
      let index = 0
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex(el => el.IsMain == true)
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex(el => el.IsMain == false)
      } else {
        //获取当前传入id的索引
        index = arr.findIndex(el => id == el.UnitId)
      }
      return index
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].UnitName = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType1=this.tableData[index].Units[findIndex].ChangeType

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    onSelect(e, row) {
      this.editT(row)
      ;(row.Grammage = e.Grammage), (row.HasGrammage = e.HasGrammage), (row.Variable = e.Variable)
      row.IsBatchNumber = e.BatchNumber ?? false
      row.BatchNumber = null
      row.BatchStartDate = row.IsBatchNumber ? row.BatchStartDate : null
      row.ColorId = null
      row.PropertyId = null
      row.Barcode = e.ProductNo + '*0*0'

      row.SourceId = 0
      row.SourceType = 0
      row.SourceDtsId = 0
      row.SourceNo = ''
      console.log(e, 'e')
      row.Colors = []
      row.Units2 = []
      row.UnitId2 = e.UnitId2
      row.UnitId = e.PdUnitId
      row.ChangeType = 0
      row.UnitType = 0
      row.ProductName = e.ProductName
      row.ProductId = e.ProductId
      row.ProductNo = e.ProductNo
      row.ProductSpec = e.ProductSpec
      row.Colors = e.Colors
      row.Units = e.Units
      row.WarehouseId = this.data.WarehouseId
      row.WarehouseName = this.data.WarehouseName
      row.UseColor = e.UseColor
      row.UseProcess = e.UseProcess
      row.ExistQuantity = e.ExistQuantity
      //AvailableQuantityStockQuantity

      row.AvailableQuantity = e.StockQuantity
      if (this.data.WarehouseId == 0 || this.data.WarehouseId == null) return this.$message.warning('请先选择仓库')

      if (e.Units.length === 0) {
        row.UnitId = e.PdUnitId
        row.UnitName = e.PdUnitName
        row.UnitId2 = 0
        row.UnitName2 = ''
        row.Rate = 0
        row.Quantity2 = 0
      } else {
        row.UnitType = 1
        e.Units.forEach(item => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType
        })
        if (row.UnitId) {
          let index = this.getUnitIndex(3, e.Units, row.UnitId)
          let data = this.getUnitValue(e.Units, index)
          let assistIndex = 0
          let assistData = {}
          row.IsMain = data.IsMain
          row.UnitName = data.UnitName
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = assistData.Rate.toFixed(5)
          } else {
            assistIndex = this.getUnitIndex(1, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = data.Rate.toFixed(5)
          }
          row.UnitId2 = assistData.UnitId
          row.UnitName2 = assistData.UnitName
        } else {
          let untiLength = e.Units.length
          let mainData = []
          let noMainData = []
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.UnitId = mainData[0].UnitId
          row.UnitName = mainData[0].UnitName
          row.UnitId2 = noMainData[0].UnitId
          row.UnitName2 = noMainData[0].UnitName
          row.Rate = noMainData[0].Rate.toFixed(5)
          row.IsMain = true
        }
      }
      // if(e.Units.length !== 0){
      //   let Units = e.Units.filter((item) => {
      //     return item.IsMain;
      //   });
      //   if (Units.length !== 0) {
      //     row.ChangeType = Units[0].ChangeType;
      //     row.Rate1 = Units[0].Rate;
      //     row.UnitId = Units[0].UnitId;
      //     row.UnitName = Units[0].UnitName;
      //   }

      //   row.Units2 = e.Units.filter((item) => {
      //     return !item.IsMain;
      //   });

      //   if(row.Units2.length !== 0){
      //     row.UnitId2 = row.Units2[0].UnitId;
      //     row.UnitName2 = row.Units2[0].UnitName;

      //     row.Rate2 = row.Units2[0].Rate;
      //     row.ChangeType2 = row.Units2[0].ChangeType;

      //     row.Rate = row.Rate1 / row.Rate2;
      //   }else{
      //     row.UnitId = e.SkUnitId;
      //     row.UnitName = e.SkUnitName;
      //     row.UnitId2 = e.SkUnitId;
      //     row.UnitName2 = e.SkUnitName;
      //     row.ChangeType = 0
      //     row.ChangeType2 = 0
      //     row.Rate = 1
      //   }

      // }else{
      //   row.UnitId = e.SkUnitId;
      //   row.UnitName = e.SkUnitName;
      //   row.UnitId2 = e.SkUnitId;
      //   row.UnitName2 = e.SkUnitName;
      //   row.ChangeType = 0
      //   row.ChangeType2 = 0
      //   row.Rate = 1
      // }
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }, row) {
      this.pageParams.pageIndex = val
      this.pdApi.list({ pageIndex: val, Property: '销售', pageSize: 7, Status: 1, ProductName: text1 }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    inputText(text, row) {
      row.ProductName = text
      this.pdApi.list({ pageIndex: 1, pageSize: 7, Property: '销售', ProductName: text, Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    RateChange(data, row, index) {
      if (data < 0 || data == '') return
      this.editT(row)
      row.Rate = data
      row.Rate = Number(row.Rate).toFixed(2)
      // this.changeQuantity(this.tableData[index].Quantity,row,index)
      if (row.IsMain) {
        // row.Quantity2 = (row.Quantity / Number(data)).toFixed(2);
        row.Quantity2 = this.getQuantity(row.Quantity / Number(data))
      } else {
        // row.Quantity = (row.Quantity2 / Number(data)).toFixed(2);
        row.Quantity = this.getQuantity(row.Quantity2 / Number(data))
      }

      let val = this.setNumber(row.Amount / row.Quantity)
      row.Price = this.getPrice(val)

      val = this.setNumber(row.Amount / row.Quantity2)
      row.Price2 = this.getPrice(val)
    },
    async openDialog(type) {
      const res = await this.sourceTypeApi.info('销售出库单')
      let OrderTypeFilter = res.SourceTypeId
      if (type === '销售订单') {
        let that = await this.$refs.saleOrderDialog.open()
        that.$refs.list.getData({ Status: 3, LineAbort: false, OrderTypeFilter })
      } else if (type === '发货通知单') {
        let that = await this.$refs.deliveryDialog.open()
        that.$refs.list.getData({DeliveryStatus:1, OrderType: OrderTypeFilter});
      } else {
        let that = await this.$refs.saleDialog.open()
        that.setBypeId(this.data.BusinessTypeId)
        that.$refs.list.getData({ Status: 2, OrderType: OrderTypeFilter, BusinessTypeId: this.data.BusinessTypeId })
      }
    },
    del(row, index) {
      this.$confirm('确认删除这条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        if (row.T !== 0) {
          row.T = 2
          row.ColorId = row.ColorId ? row.ColorId : 0
          row.PropertyId = row.PropertyId ? row.PropertyId : 0
          row.WarehouseId = row.WarehouseId ? row.WarehouseId : 0
          this.delTableData.push(row)
        }
        this.tableData.splice(index, 1)
        if (this.tableData.length === 0) {
          this.newLine()
        }
      })
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    newLine() {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        WarehouseId: null,
        WarehouseName: '',
        ProductNo: '',
        ProductName: '',
        ProductId: null,
        ColorId: null,
        ColorName: '',
        Colors: [],
        UnitName: '',
        UnitName2: '',
        UnitId: null,
        Units: [],
        Quantity: null,
        ReQuantity: null,
        Price: null,
        Amount: null,
        UnitId2: null,
        UnitNmae2: '',
        Quantity2: null,
        ReQuantity2: null,
        QuotedPrice: null,
        Discount: null,
        Price2: null,
        Rate: null,
        SourceId: 0,
        SourceType: 0,
        SourceDtsId: 0,
        SourceNo: '',
        IsGift: false,
        AvailableQuantity: null,
        ExistQuantity: null,
        SaleOrderNo: '',
        PropertyId: null,
        PropertyName: '',
        Remark: '',
        BatchNumber: ''
      }

      this.tableData.push(o)
    },
    add(row, column) {
      if (column.label === '操作') {
        return
      }
      if (row.index === this.tableData.length - 1) {
        this.newLine()
      }
    },
    getProducts(data) {
      let Products = []

      data.forEach(item => {
        let {
          T,
          DocId,
          DocProductId,
          WarehouseId,
          WarehouseName,
          ProductNo,
          ProductName,
          ProductId,
          ColorId,
          ColorName,
          Colors,
          UnitName,
          UnitName2,
          UnitId,
          Units,
          Quantity,
          ReQuantity,
          Price,
          Amount,
          UnitId2,
          Quantity2,
          ReQuantity2,
          QuotedPrice,
          Discount,
          Price2,
          Rate,
          SourceDocId,
          SourceDocNo,
          IsGift,
          AvailableQuantity,
          ExistQuantity,
          SaleOrderNo,
          PropertyId,
          PropertyName,

          SourceId,
          SourceType,
          SourceDtsId,
          SourceNo,
          ChangeType,
          Remark,
          UseColor,
          UseProcess,
          BatchNumber,
          PackingQuantity,
          PackingSpeciId,
          Grammage,
          Barcode,
          RealPackingNumber
        } = item

        ColorId = ColorId ? ColorId : 0
        PropertyId = PropertyId ? PropertyId : 0
        WarehouseId = WarehouseId ? WarehouseId : 0
        Price = Price ?? 0
        Price2 = Price2 ?? 0
        Amount = Amount ?? 0

        let o = {
          T,
          DocId,
          DocProductId,
          WarehouseId,
          WarehouseName,
          ProductNo,
          ProductName,
          ProductId,
          ColorId,
          ColorName,
          Colors,
          UnitName,
          UnitName2,
          UnitId,
          Units,
          Quantity,
          ReQuantity,
          Price,
          Amount,
          UnitId2,
          Quantity2,
          ReQuantity2,
          QuotedPrice,
          Discount,
          Price2,
          Rate,
          SourceDocId,
          SourceDocNo,
          IsGift,
          AvailableQuantity,
          ExistQuantity,
          SaleOrderNo,
          PropertyId,
          PropertyName,

          SourceId,
          SourceType,
          SourceDtsId,
          SourceNo,
          ChangeType,
          Remark,
          UseColor,
          UseProcess,
          BatchNumber,
          PackingQuantity,
          PackingSpeciId,
          Grammage,
          Barcode,
          RealPackingNumber
        }

        Products.push(o)
      })

      return Products
    },
    save(type = 0) {
      //  //验证表单是否填写
      // let yanzheng = ['DocDate','DocNo', 'BusinessTypeId', 'TradeUnitId', 'WarehouseId', 'EmpId', ]

      // for(let key in this.data){

      //   if(yanzheng.indexOf(key) !== -1 && (!this.data[key])){
      //     this.$message({type: 'warning', message: '表单未填写完整'})
      //     return;
      //   }
      // }
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return false
        let Products = this.getProducts(this.tableData)
        this.keepData = Products
        if (Products.length > 0 && Products[0].ProductName != '') {
        } else {
          this.$message({ type: 'warning', message: '明细列表不能为空' })
          return
        }

        Products = Products.filter(item => {
          return item.T != null && item.ProductId !== 0 && item.ProductId != null
        })
        var btId = 0
        var obj = this.businessTypeList.find(x => x.BusinessType == '销售退货')
        if (obj) btId = obj.BusinessTypeId

        let ProductsLength = Products.length
        for (let i = 0; i < ProductsLength; ++i) {
          if (this.data.BusinessTypeId == btId && btId) {
            if (Products[i].Amount > 0) {
              this.$message({ type: 'warning', message: '金额不能大于0' })
              return
            }
          } else {
            if (Products[i].Amount < 0) {
              this.$message({ type: 'warning', message: '金额不能小于0' })
              return
            }
          }
          if (!Products[i].Quantity) {
            this.$message({ type: 'warning', message: '实发数量要大于0' })
            return
          }
          if (Products[i].UseColor && Products[i].ColorId === 0) {
            this.$message.error(`存货${Products[i].ProductName}未填写颜色`)
            return
          }
          // if (Products[i].UseProcess && Products[i].PropertyId === 0) {
          //   this.$message.error(`存货${Products[i].ProductName}未填写属性`)
          //   return
          // }
        }

        Products = Products.concat(this.delTableData)

        let o = {
          Products,
          ...this.data
        }

        this.api.save(o).then(res => {
          if (res.Code === 0) {
            if (this.viewType === 'create') {
              this.data.DocId = res.Data
            }
            if (type !== 1) {
              this.$message.success(res.Msg)
            }
            this.isSave = true

            this.api.info(this.data.DocId).then(res => {
              if (res.Code === 0) {
                this.$route.params.data = res.Data
                if (type === 1) {
                  this.reView1()
                } else {
                  this.editInit(res.Data, 'keep')
                }
              }
            })
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      })
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: 'warning', message: '请先进行保存再操作' })
        return
      } else {
        Object.assign(this.$data, this.$options.data.call(this))
        this.$route.params.type = 'create'
        this.viewType = 'create'
        this.init()
        this.getPreviewNo()
        this.isSave = false
        this.editTrade = true
      }
    },
    handleDelete() {
      let Id = this.data.DocId
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.api.delete({ Id }).then(res => {
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.newAdd()
            // this.$emit('deleted')
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      })
    },
    reView1() {
      let id = this.data.DocId
      this.api.examine(id).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              console.log(res.Data, 'res.Data')
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.DocId
      this.api.cancelExamine(id).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    getSelect(row) {
      console.log('row', row)
    },
    /** 打开批号弹框 */
    onOpenBatch(e, row, index) {
      this.batchPageParams.pageIndex = 1
      let o = {
        IsInOut: 1,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.ColorId,
        pageIndex: 1,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 选择批号 */
    onSelBatch(e, row, index) {
      if (row.T !== 0) {
        row.T = 1
      }
      if (e.BatchNumber !== row.BatchNumber) {
        this.tableData[index].BatchNumber = e.BatchNumber
        this.tableData[index].ExistQuantity = e.BaseQuantity
      }
    },
    /** 输入批号 */
    inputTextBatch(text, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = text
      //IsInOut 入库-0 出库-1
      let o = {
        IsInOut: 1,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.ColorId,
        BatchNumber: row.BatchNumber,
        pageIndex: 1,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 批号下一页 */
    currentPageBatch({ val, text1 }, row) {
      this.batchPageParams.pageIndex = val
      let o = {
        IsInOut: 1,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.ColorId,
        ProductName: row.ProductName,
        pageIndex: val,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },

    onPrint(row) {
      let newpage = this.$router.resolve({
        path: '/selloutwarehousePrint?id=' + row.DocId
      })
      window.open(newpage.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.input-with-select .el-input__inner {
  border: 1px solid #d5d5d5 !important;
  border-radius: 4px !important;
}
.input-with-select .el-input-group__append {
  border: 1px solid #d5d5d5 !important;
}
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;

  .text {
    width: 60px;
  }
}

.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}

.span {
  display: inline-block;
  width: 180px;
}
</style>
